import { getMemoizedRouter } from 'router/router-instance';
import desktopRoutes from 'router/routes';

import { isMobile } from '@neptune/shared/common-util';

import { desktopRouterConfig } from 'router/config';

import {
  LeaderboardLoadTransaction,
  OnboardingProjectsLoadTransaction,
  ProjectsLoadTransaction,
} from './transactions';

export const initTransactions = () => {
  const router = getMemoizedRouter(desktopRoutes, desktopRouterConfig);
  const initParams = {
    route: router.matchUrl(window.location.href),
    isMobile: isMobile(),
  };

  LeaderboardLoadTransaction(initParams);
  ProjectsLoadTransaction(initParams);
  OnboardingProjectsLoadTransaction(initParams);
};
